import { render, staticRenderFns } from "./m-mix-paiban-plan-modal.vue?vue&type=template&id=613f4460&scoped=true&"
import script from "./m-mix-paiban-plan-modal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-mix-paiban-plan-modal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-mix-paiban-plan-modal.vue?vue&type=style&index=0&id=613f4460&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f4460",
  null
  
)

export default component.exports